/* ============================================================
   IRAYS – COMPLETE THE LOOK
   FINAL DOM-DRIVEN + REVY CALLBACK VERSION
   ============================================================ */

(function () {
  if (window.__IRAYS_CTL_LOADED__) return;
  window.__IRAYS_CTL_LOADED__ = true;

  function log() {
    if (window.IRAYS_CTL_DEBUG) {
      console.log.apply(console, ['[IRAYS CTL]'].concat(arguments));
    }
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* ------------------------------------------------------------
     WAIT FOR REVY (OFFICIAL CALLBACK API + DOM FALLBACK)
     ------------------------------------------------------------ */
  function waitForRevy(cb) {
    window.revyBundleDataLayer = window.revyBundleDataLayer || [];

    let done = false;
    function finish(source) {
      if (done) return;
      done = true;
      log('Revy ready via', source);
      cb();
    }

    // OFFICIAL CALLBACKS (from Revy docs)
    window.revyBundleDataLayer.push({
      onReady: function () {
        finish('callback:onReady');
      },
      onLoad: function () {
        finish('callback:onLoad');
      }
    });

    // DOM fallback (bullet-proof)
    const i = setInterval(function () {
      const revyRoot =
        document.querySelector('#revy-bundle-app') ||
        document.querySelector('[id*="revy"]');

      if (revyRoot && revyRoot.children.length > 0) {
        clearInterval(i);
        finish('dom-detected');
      }
    }, 250);
  }

  /* ------------------------------------------------------------
     DOM PARSER (NO JSON / NO GLOBAL OBJECTალა)
     ------------------------------------------------------------ */
  function extractBundleFromDOM() {
    const widget =
      document.querySelector('#revy-bundle-app') ||
      document.querySelector('[id*="revy"]');

    if (!widget) return null;

    // Titles
    const productLinks = widget.querySelectorAll('a[href*="/products/"]');
    if (productLinks.length < 2) return null;

    const handles = [];
    productLinks.forEach(a => {
      const m = a.getAttribute('href').match(/\/products\/([^/?]+)/);
      if (m && !handles.includes(m[1])) handles.push(m[1]);
    });

    if (handles.length < 2) return null;

    // Discount (percentage)
    let discount = 0;
    const discountEl = widget.querySelector('[class*="discount"], [class*="save"]');
    if (discountEl) {
      const m = discountEl.textContent.match(/(\d+)%/);
      if (m) discount = parseInt(m[1], 10);
    }

    return {
      handles,
      discount
    };
  }

  /* ------------------------------------------------------------
     MAIN RENDER
     ------------------------------------------------------------ */
  function renderUI(bundle) {
    const root = document.getElementById('irays-complete-the-look');
    if (!root) return;

    root.innerHTML = `
      <div class="irays-ctl-card">
        <div class="irays-ctl-header">
          <div class="irays-ctl-eyebrow">Complete the look</div>
          <div class="irays-ctl-title">Elevate your look</div>
          ${
            bundle.discount
              ? `<div class="irays-ctl-sub">Save ${bundle.discount}% when bought together</div>`
              : ''
          }
        </div>

        <div class="irays-ctl-items">
          <div class="irays-ctl-item">${bundle.handles[0]}</div>
          <div class="irays-ctl-plus">+</div>
          <div class="irays-ctl-item">${bundle.handles[1]}</div>
        </div>

        <div class="irays-ctl-actions">
          <button class="irays-ctl-add">Add bundle to cart</button>
        </div>
      </div>
    `;
  }

  /* ------------------------------------------------------------
     BOOTSTRAP
     ------------------------------------------------------------ */
  ready(function () {
    const root = document.getElementById('irays-complete-the-look');
    if (!root) return;

    // ALWAYS VISIBLE – NEVER HIDDEN
    root.innerHTML = `<div class="irays-ctl-loading">Loading bundle…</div>`;

    waitForRevy(function () {
      const bundle = extractBundleFromDOM();

      if (!bundle) {
        log('No bundle found in DOM');
        root.innerHTML = '';
        return;
      }

      renderUI(bundle);
    });
  });

})();